import { render, staticRenderFns } from "./main-tutor-list.html?vue&type=template&id=db67f120&scoped=true&"
import script from "./main-tutor-list.ts?vue&type=script&lang=ts&"
export * from "./main-tutor-list.ts?vue&type=script&lang=ts&"
import style0 from "./main-tutor-list.styl?vue&type=style&index=0&id=db67f120&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db67f120",
  null
  
)

export default component.exports